type Params = {
  displayName: string | null | undefined
  email: string | null | undefined
}

export const resolveProfileIdentity = ({ displayName, email }: Params) => {
  const profileName = displayName?.trim() || email?.trim() || 'Cliente'
  const profileInitials =
    profileName
      .split(/\s+/)
      .map((token) => token.trim()[0] || '')
      .join('')
      .slice(0, 2)
      .toUpperCase() || 'CL'

  return { profileName, profileInitials }
}
